import styled, { css } from 'styled-components'

export const pageWrapperStyle = css`
  padding: 0 156px;
`

export const Page = styled.main`
  ${pageWrapperStyle}
`
